var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackToResultArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 8,
    viewBox: "0 0 5 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.50439 7.7496L0.256607 4.60452C-0.0855341 4.27065 -0.0855339 3.72935 0.256607 3.39548L3.5044 0.250402C3.84654 -0.0834654 4.40126 -0.0834652 4.7434 0.250402C5.08554 0.584271 5.08554 1.12558 4.7434 1.45945L2.11511 4L4.7434 6.54056C5.08554 6.87443 5.08554 7.41573 4.74339 7.7496C4.40125 8.08347 3.84653 8.08347 3.50439 7.7496Z",
    fill: "#007A9C",
    className: "hc-arrow"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackToResultArrow);
export default __webpack_public_path__ + "static/media/back-to-result-arrow.7e64fbdc73d6ff5b6c15ebc1e1da8f09.svg";
export { ForwardRef as ReactComponent };